/* Análise → Meus gráficos: painel com os gráficos salvos pela empresa. */

import { api } from '../../core/api';
import { state } from '../../core/estado';
import { esc, lista } from '../../core/formato';
import type { Agregado, GraficoSalvo } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { loading } from '../../ui/componentes';
import { ic } from '../../ui/dom';
import { filtrosBar } from '../../ui/filtros';
import { graficoPersonalizado } from '../../ui/graficoPersonalizado';
import { toast } from '../../ui/toast';
import { ir, render } from '../../roteador';
import type { Pagina } from '../pagina';
import { paramsDoGrafico } from './graficoComum';

let salvos: GraficoSalvo[] = [];

const vazioHtml = () => `<div class="empty">
  <div class="icn">${ic('i-chart')}</div>
  <h3>Nenhum gráfico salvo ainda</h3>
  <p>Monte um gráfico com as variáveis que quiser acompanhar e salve aqui. Ele vai seguir o ano e a obra escolhidos nos filtros.</p>
  <a class="btn btn-primary" href="#/analise/montar">${ic('i-plus')} Montar um gráfico</a></div>`;

function cartao(g: GraficoSalvo): string {
  return `<div class="card">
    <div class="between" style="margin-bottom:14px;align-items:flex-start">
      <div><h2 class="sec" style="margin:0">${esc(g.titulo)}</h2></div>
      <div class="row no-print" style="gap:4px">
        <button class="btn btn-plain" style="padding:6px 10px" data-clique="editar" data-id="${esc(g.id)}" title="Abrir no construtor">Editar</button>
        <button class="btn btn-plain" style="padding:6px 10px;color:var(--danger)" data-clique="apagar" data-id="${esc(g.id)}" title="Apagar gráfico">Apagar</button>
      </div>
    </div>
    <div id="g-${esc(g.id)}">${loading('Montando gráfico…')}</div>
  </div>`;
}

export const meusGraficos: Pagina = {
  render: () => `
  <div class="between wrap"><div><h1 class="page">Meus gráficos</h1>
    <p class="sub">Os gráficos que você montou e salvou. Todos seguem o ano e a obra escolhidos abaixo.</p></div>
    <a class="btn btn-ghost no-print" href="#/analise/montar">${ic('i-plus')} Novo gráfico</a></div>
  ${filtrosBar()}
  <div id="grafLista">${loading()}</div>`,

  carregar(tk) {
    carregar(tk, [{
      id: 'grafLista',
      busca: () => api<GraficoSalvo[]>('GET', '/graficos'),
      html: (d: GraficoSalvo[]) => {
        salvos = lista<GraficoSalvo>(d);
        if (!salvos.length) return vazioHtml();
        // Os gráficos carregam depois que os cartões existirem na tela.
        queueMicrotask(() => carregar(tk, salvos.map((g) => ({
          id: `g-${g.id}`,
          busca: () => api<Agregado>('GET', '/agregado', { params: paramsDoGrafico(g.config) }),
          html: (a: Agregado) => graficoPersonalizado(a),
        }))));
        return `<div class="grid g2" style="align-items:start">${salvos.map(cartao).join('')}</div>`;
      },
    }]);
  },

  acoes: {
    editar(el) {
      const g = salvos.find((x) => x.id === el.dataset.id);
      if (!g) return;
      state.grafico = structuredClone(g.config);
      state.graficoTitulo = g.titulo;
      ir('#/analise/montar');
    },

    async apagar(el) {
      const g = salvos.find((x) => x.id === el.dataset.id);
      if (!g || !window.confirm(`Apagar o gráfico "${g.titulo}"?`)) return;
      try {
        await api('DELETE', `/graficos/${encodeURIComponent(g.id)}`);
        toast('Gráfico apagado.');
        render();
      } catch (e) {
        toast((e as Error).message || 'Não foi possível apagar o gráfico.');
      }
    },
  },
};
